export function runSequentially(
  items,
  asyncHandler,
  { msBetweenEachRun = 0 } = {},
) {
  return new Promise((resolve, reject) => {
    (function next(index) {
      setTimeout(async () => {
        try {
          if (items[index]) {
            await asyncHandler(items[index]);
            next(index + 1);
          } else {
            resolve();
          }
        } catch (error) {
          reject(error);
        }
      }, msBetweenEachRun);
    })(0);
  });
}
